import { ApiProperty } from "@nestjs/swagger";

export class PackingBomFilter {
    @ApiProperty()
    saleOrderIds: number[];
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    itemName: number[];
    @ApiProperty()
    endCustomerId:number;
    @ApiProperty()
    itemSubCategoryId:number
}